export default "__VITE_ASSET__BDey2R3S__"